// Turn people mentions — `[Name](urn:bb:contact:N)` / `urn:bb:person:N` — into
// plain `Name`, leaving every other link intact (regular URLs and non-person
// URNs like attachments). Used to present a memory for plain-text editing; the
// backend relink job only rebuilds these contact/person mentions on save, so
// anything else it can't rebuild must be preserved.
export const unlinkMentions = (content: string): string =>
  content.replace(
    /\[([^\]]*)\]\(urn:bb:(?:contact|person):[^)]+\)/g,
    (_match, label: string) => label,
  );
